export default {
  'component.fileManager.label.baseDir': 'Path',
  'component.fileManager.label.folders': 'Folders',
  'component.fileManager.label.files': 'Files',
  'component.fileManager.can-not-delete-root-dir': 'Can not delete root directory!',
};
